import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { coreReducer, featureName } from '../../../core/store/core.reducer';
import { AccountService } from '../../../account/services/account.service';
import { BrandingService } from '../../../branding/services/branding.service';
import { BulkUploadService } from '../../../bulk-upload/services/bulk-upload.service';
import { AssetsService } from '../../../files/services/assets.service';
import { FilesService } from '../../../files/services/files.service';
import { FilesBulkDeliveryService } from '../../../files-bulk-delivery/services/files-bulk-delivery.service';
import { IntegrationsService } from '../../../integrations/services/integrations.service';
import { MessagesService } from '../../../messages/services/messages.service';
import { NetworksService } from '../../../networks/services/networks.service';
import { PaymentMethodsService } from '../../../payment-methods/services/payment-methods.service';
import { PlansService } from '../../../plans/services/plans.service';
import { PricesService } from '../../../prices/services/prices.service';
import { RecordTypesService } from '../../../record-types/services/record-types.service';
import { RecordsService } from '../../../records/services/records.service';
import { XlsxService } from '../../../shared/services/xlsx.service';
import { SideDrawersService } from '../../../sidedrawers/services/side-drawers.service';
import { SubscriptionsService } from '../../../subscriptions/services/subscriptions.service';
import { TeamsService } from '../../../teams/services/teams.service';
import { TemplatesService } from '../../../templates/services/templates.service';
import { UsersService } from '../../../users/services/users.service';
import { InvitationsService } from '../../../invitations/services/invitations.service';
import { AccountModule } from '../../../account/account.module';
import { DictionaryModule } from '../../../dictionary/dictionary.module';
import { DragDropOverlaySnackBarContainer } from '../../../files/directives/drag-and-drop/directive/drag-and-drop/drag-drop-overlay-container';
import { SdConfirmSuccessErrorDialogService } from '../../../shared/sd-confirm-success-error-dialog/services/sd-confirm-success-error-dialog.service';
import { VaultsService } from '../../../vaults/services/vaults.service';
import { VaultsGlobalStore } from '../../../vaults/store/vaults-global.store';
import { VaultDrawersGlobalStore } from '../../../vaults/store/vault-drawers-global.store';
import { TagsService } from '../../../tags/services/tags.service';
import { TagsGlobalStore } from '../../../tags/store/tags-global.store';
import { SdIframeForIntegrationSignalStore } from 'src/app/shared/sd-iframe-for-integration-a11y/store/sd-iframe-for-integration-signal.store';
import { InvitationsGlobalStore } from '../../../invitations/store/invitations-global.store';
import { MatDialogModule } from '@angular/material/dialog';
import { SdCommentsTenantService } from 'src/app/comments/services/sd-comments-tenant.service';
import { FormRequestsGlobalStore } from '../../../plans/store/form-requests-global.store';
import { CibcCoreRoutingModule } from './cibc-core-routing.module';
import { EffectsModule } from '@ngrx/effects';
import { CoreEffects } from 'src/app/core/store/core.effects';
import { DragAndDropModule } from 'src/app/files/directives/drag-and-drop/drag-and-drop.module';
import { NgIf } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SdFormsModule } from 'src/app/shared/sd-forms/sd-forms.module';
import { SdAlertsModule } from 'src/app/shared/sd-alerts/sd-alerts.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SdButtonsModule } from 'src/app/shared/sd-buttons/sd-buttons.module';
import { StatusFlagsGlobalStore } from 'src/app/status-flags/store/status-flags-global.store';
import { StatusFlagsService } from 'src/app/status-flags/services/status-flags.service';

@NgModule({
  declarations: [],
  imports: [
    CibcCoreRoutingModule,
    StoreModule.forFeature(featureName, coreReducer),
    EffectsModule.forFeature([CoreEffects]),
    AccountModule,
    DictionaryModule,
    SdButtonsModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    SdAlertsModule,
    SdFormsModule,
    MatProgressBarModule,
    NgIf,
    DragAndDropModule,
  ],
  providers: [
    AccountService,
    BrandingService,
    BulkUploadService,
    AssetsService,
    FilesService,
    FilesBulkDeliveryService,
    IntegrationsService,
    MessagesService,
    NetworksService,
    PaymentMethodsService,
    PlansService,
    PricesService,
    RecordTypesService,
    RecordsService,
    XlsxService,
    SideDrawersService,
    SubscriptionsService,
    TeamsService,
    TemplatesService,
    UsersService,
    InvitationsService,
    DragDropOverlaySnackBarContainer,
    SdConfirmSuccessErrorDialogService,
    VaultsService,
    VaultsGlobalStore,
    VaultDrawersGlobalStore,
    TagsService,
    TagsGlobalStore,
    StatusFlagsService,
    StatusFlagsGlobalStore,
    SdIframeForIntegrationSignalStore,
    InvitationsGlobalStore,
    SdCommentsTenantService,
    FormRequestsGlobalStore,
  ],
})
export class CibcCoreModule {}
